import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { CalendarClock } from 'lucide-react';
import { getToken } from '../../services/tokenService';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const eur = (v) => `${Number(v || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;

// Échéancier identique à celui imprimé sur le Devis ESS (standard ou personnalisé)
export const EcheancierDevis = ({ souscriptionId }) => {
  const [plan, setPlan] = useState(null);
  useEffect(() => {
    if (!souscriptionId) return;
    axios.get(`${API}/souscriptions/${souscriptionId}/echeancier-devis`, { headers: { Authorization: `Bearer ${getToken()}` } })
      .then((r) => setPlan(r.data)).catch(() => setPlan(null));
  }, [souscriptionId]);
  if (!plan?.eligible) return null;
  const pct = Math.round(plan.acompte_pct * 100);
  return (
    <div className="rounded-xl border-2 border-amber-400 bg-amber-50 p-5" data-testid="echeancier-devis">
      <div className="mb-2 flex items-center justify-between gap-2">
        <h3 className="flex items-center gap-2 text-sm font-bold uppercase tracking-wide text-amber-900">
          <CalendarClock className="h-4 w-4" /> Échéancier du Devis ESS
        </h3>
        <span className="rounded-full bg-amber-200 px-2 py-0.5 text-[10px] font-bold text-amber-900" data-testid="echeancier-devis-type">
          {plan.personnalise ? 'PERSONNALISÉ' : 'STANDARD'}
        </span>
      </div>
      <table className="w-full text-sm">
        <tbody>
          <tr className="bg-amber-100 font-semibold text-amber-900">
            <td className="px-3 py-2">Montant total TTC</td>
            <td className="px-3 py-2 text-right" data-testid="echeancier-devis-total">{eur(plan.montant_total_eur)}</td>
          </tr>
          <tr className="border-b border-amber-200">
            <td className="px-3 py-2">Acompte {plan.acompte_date_fr ? `le ${plan.acompte_date_fr}` : 'à la signature'} ({pct} %)</td>
            <td className="px-3 py-2 text-right font-semibold text-amber-700" data-testid="echeancier-devis-acompte">{eur(plan.acompte_eur)}</td>
          </tr>
          {plan.echeances.map((e, i) => (
            <tr key={e.label} className="border-b border-amber-100" data-testid={`echeancier-devis-echeance-${i + 1}`}>
              <td className="px-3 py-2 text-slate-700">{e.label} · {e.date_fr}</td>
              <td className="px-3 py-2 text-right font-mono text-slate-800">{eur(e.amount_eur)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
